import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { interval, Subscription } from 'rxjs';
import { map, take, takeWhile } from 'rxjs/operators';
// services
import { LoginService } from '../../../shared/services/login.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { DataStorageService } from "../../../shared/services/data-storage.service";
// models
import { AppState } from '../../../booking/models/app-state.interface';
// globals
import { EMAIL_PATTERN } from '../../../shared/globals';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [
    LoginService
  ]
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  private _emailSentSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _validateOTPCodeSubscription: Subscription;
  private _userOTPSubscription: Subscription;
  private _dataSavedSubscription: Subscription;
  private _userStoreSubscription: Subscription;

  public emailPattern = EMAIL_PATTERN;
  public showEmailSent: Boolean = false;
  public showLoader: Boolean = false;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';

  public OTPSentToEmail = false;
  public countdown = 1;
  public isCounting: boolean = false;
  public userEmail = '';
  public is2FARequired: boolean = false;

  constructor(
    private _appStore: Store<AppState>,

    private _dataStorageService: DataStorageService,
    private _loginService: LoginService,
    private _router: Router,
    private _errorService: ErrorHandler,
    private _copyService: CopyService,
  ) { }

  ngOnInit() {

    this._userLanguageSubscription = this._appStore.select('copyReducer')
      .subscribe((res: any) => {
        this.selectedLanguage = res.language
      })

    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          this.getCopy();
        }

      })

    this._userStoreSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        this.userEmail = user.userDetails.userEmail;
        this.is2FARequired = user.userDetails.is2FARequired;

        if (user.userDetails.userEmail === '') {
          this._router.navigate(['login']);
        }

      });

    this._emailSentSubscription = this._loginService.forgotPasswordEmailSent$
      .subscribe(emailSent => {
        this.showLoader = false;

        if (emailSent.error) {
          this.handleErrors();
          return;
        }

        if (emailSent) {

          const data = {
            text: 'OTP sent to Email!',
            type: 'info',
            icon: 'alert',
            sticky: false
          };

          // if (this.getState(this._appStore).userReducer.userDetails.is2FARequired) {
          //   data.text = 'OTP sent to phone number!';
          // }
          this._errorService.handleCustomInfo(data);
        }

        this.OTPSentToEmail = emailSent;

        this.startCountDown();
      },
        err => console.log(err));

    this._validateOTPCodeSubscription = this._loginService.validateOTPCode$
      .subscribe(res => {

        if (res.error) {
          this.showLoader = false;
          return;
        }

        if (res) {
          this._appStore.dispatch({ type: 'UPDATE_USER_HAS_ACCOUNT_DETAILS', payload: true });
          this._router.navigate(['account-details']);
          return;
        }


      },
        err => console.log(err));

    this._userOTPSubscription = this._loginService.userSubject$
      .subscribe(user => {
        if (user.error) {
          this.handleError();
        }

        this._appStore.dispatch({ type: 'USER_ACCOUNT_UPDATE_STATUS', payload: true });
        // save data and redirect
        this._dataStorageService.saveData();
      },
        err => console.log(err));

    this._dataSavedSubscription = this._dataStorageService.dataSaved$.subscribe(
      (res) => {
        if (res) {
          // redirect after data saved
          this._router.navigate(['account-details']);
        }
      }
    );

  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'Password',
      ['resetPassword']
    );
    console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  handleError() {
    this.showLoader = false;
    this._errorService.handleCustomInfo({
      text: 'Something went wrong!',
      type: 'info'
    });
  }


  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  handleErrors() {
    this.showLoader = false;
  }

  goToLogin() {
    this._router.navigate(['login']);
  }

  handleSubmitForgotPassword(value, e) {

    e.preventDefault();
    this.showLoader = true;

    if (value.otp) {
      this.handleSubmitOTP(value);
      return
    }

    // if(this.is2FARequired) {
    //   this._loginService.SendOneTimeLoginCode(this.userEmail);
    // } else {
    this._loginService.sendOTP(this.userEmail);
    // }

  }

  resendEmail(e) {
    e.preventDefault();
    // if(this.is2FARequired) {
    //   this._loginService.SendOneTimeLoginCode(this.userEmail);
    // } else {
    this._loginService.sendOTP(this.userEmail);
    // }
  }

  handleSubmitOTP(value) {
    this._loginService.validateOTPCode(value.otp, this.userEmail, 'forgot-password', this.is2FARequired);
  }

  startCountDown() {
    if (this.isCounting) return; // Prevent multiple intervals
    this.isCounting = true;
    this.countdown = 60;

    interval(1000) // Emit every second
      .pipe(
        takeWhile(() => this.countdown > 1),  // Stop when countdown reaches 1
        map(() => --this.countdown) // Decrease countdown by 1
      )
      .subscribe({
        complete: () => {
          this.isCounting = false; // Reset state after countdown ends
          this.countdown = 1; // Ensure countdown ends at 0
        }
      });
  }

  ngOnDestroy() {
    this._validateOTPCodeSubscription.unsubscribe();
    this._userOTPSubscription.unsubscribe();
    this._emailSentSubscription.unsubscribe();
    this._userLanguageSubscription.unsubscribe();
    this._bookingInitSubscription.unsubscribe();
    this._validateOTPCodeSubscription.unsubscribe();
    this._userOTPSubscription.unsubscribe();
    this._dataSavedSubscription.unsubscribe();
  }

}
